import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Link = styled.a`
  font-weight: lighter;
  color: #56565A;
  &:hover {
    text-decoration: none;
  }
`
const TitleContainer = styled.div`
  font-weight: 600;
`
const SubNavLink = ({ link: { href, title } }) => {
  return href ? (
    <Link href={href}>
      {title}
    </Link>
  ) : (
    <TitleContainer>
      {title}
    </TitleContainer>
  )
}

SubNavLink.propTypes = {
  link: PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string.isRequired
  }).isRequired
}

export default SubNavLink
